/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class FileNoneCopyIcon extends BaseIcon {
  getChildren = () => [
    <polygon fill={ this.getColor() } points="15 12.55 15 0 1 0 1 16 11.55 16 15 12.55"/>,
    <rect fill="#fff" x="4" y="5" width="8" height="1"/>,
    <rect fill="#fff" x="4" y="8" width="8" height="1"/>,
    <rect fill="#fff" x="4" y="11" width="8" height="1"/>
  ]
  getViewBox = () => '0 0 16 16'
}
